<ng-template #bulkUserActionsModalForm let-modal>

  <app-modal-comp-header
    [title]="'Bulk Action — ' + actionLabel"
    (cancelButtonOnClick)="cancelForm()"
  ></app-modal-comp-header>

  <div class="modal-body">

    <!--#region Configure-->
    @if (step === 'configure') {
      <div class="row">
        <div class="col-lg-8 offset-lg-2">

          @if (action === BulkUserAction.TransferCompany) {
            <div class="mb-3">
              <label class="form-label" for="bulkTransferCompany">Transfer To Company</label>
              <select id="bulkTransferCompany"
                      class="form-select"
                      [class.is-invalid]="formSubmitted && !canProceedConfigure()"
                      [(ngModel)]="selectedCompanyId">
                <option [ngValue]="null" disabled>Select a company&hellip;</option>
                @for (company of companies; track company.id) {
                  <option [ngValue]="company.id">{{ company.description }}</option>
                }
              </select>
              <div class="invalid-feedback">Please select a company.</div>
            </div>

            <div class="alert alert-info" role="alert">
              <i class="ri-information-line align-bottom me-1"></i>
              Each subscriber's SIMs move with them. A subscriber holding no SIMs is still transferred.
            </div>

            @if (formSubmitted && canProceedConfigure() && totalCount <= 0) {
              <div class="alert alert-warning mb-0" role="alert">
                <i class="ri-alert-line align-bottom me-1"></i>
                Every selected subscriber is already assigned to {{ selectedCompanyName }}. Please choose a different company.
              </div>
            }
          }

        </div>
      </div>
    }
    <!--#endregion-->

    <!--#region Confirm-->
    @if (step === 'confirm') {
      <div class="alert alert-warning" role="alert">
        <span [innerHtml]="confirmSummary"></span>
      </div>

      @if (skippedRows.length > 0) {
        <div class="alert alert-info" role="alert">
          <i class="ri-information-line align-bottom me-1"></i>
          {{ skippedRows.length }} selected subscriber(s) are already assigned to {{ selectedCompanyName }} and will be left alone.
        </div>
      }

      <p class="mb-2"><strong>{{ totalCount }}</strong> subscriber(s) will be affected:</p>

      <div class="table-responsive border rounded" style="max-height: 45vh; overflow-y: auto;">
        <table class="table table-sm table-striped align-middle mb-0">
          <thead class="table-light" style="position: sticky; top: 0;">
            <tr>
              <th>Subscriber</th>
              <th>From Company</th>
              <th>To Company</th>
            </tr>
          </thead>
          <tbody>
            @for (row of runRows; track row.userId) {
              <tr>
                <td>{{ row.userName }}</td>
                <td>{{ row.companyName }}</td>
                <td>{{ selectedCompanyName }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <!--#endregion-->

    <!--#region Progress-->
    @if (step === 'progress') {
      <p class="mb-2">Processing {{ currentIndexDisplay }} of {{ totalCount }}&hellip;</p>

      <div class="progress mb-3" style="height: 22px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-info"
             role="progressbar"
             [style.width.%]="progressPercent"
             [attr.aria-valuenow]="progressPercent"
             aria-valuemin="0"
             aria-valuemax="100">
          {{ progressPercent }}%
        </div>
      </div>

      <div class="d-flex gap-3">
        <span class="text-success"><i class="ri-check-line"></i> Succeeded: {{ successCount }}</span>
        <span class="text-danger"><i class="ri-close-line"></i> Failed: {{ errorCount }}</span>
      </div>
    }
    <!--#endregion-->

    <!--#region Complete-->
    @if (step === 'complete') {
      <div class="text-center mb-4">
        <h4 class="mb-2">Action Complete</h4>
        <p class="text-muted mb-0">
          <span class="text-success">{{ successCount }} succeeded</span>
          @if (errorCount > 0) { <span class="text-danger">, {{ errorCount }} failed</span> }
          of {{ totalCount }}.
        </p>
      </div>

      <div class="table-responsive border rounded" style="max-height: 45vh; overflow-y: auto;">
        <table class="table table-sm table-striped align-middle mb-0">
          <thead class="table-light" style="position: sticky; top: 0;">
            <tr>
              <th>Result</th>
              <th>Subscriber</th>
              <th>From Company</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            @for (result of results; track result.userId) {
              <tr>
                <td>
                  @if (result.ok) {
                    <span class="badge bg-success">Completed</span>
                  } @else {
                    <span class="badge bg-danger">Failed</span>
                  }
                </td>
                <td>{{ result.userName }}</td>
                <td>{{ result.companyName }}</td>
                <td class="text-danger">{{ result.message }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <!--#endregion-->

  </div>

  <div class="modal-footer">

    @if (step === 'configure') {
      <button type="button" class="btn btn-light" (click)="cancelForm()">Cancel</button>
      <button type="button" class="btn btn-info add-btn" [disabled]="!canProceedConfigure()" (click)="next()">Next</button>
    }

    @if (step === 'confirm') {
      <button type="button" class="btn btn-light" (click)="cancelForm()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="confirm()">Confirm</button>
    }

    @if (step === 'progress') {
      <button type="button" class="btn btn-light" disabled>Please wait&hellip;</button>
    }

    @if (step === 'complete') {
      <button type="button" class="btn btn-light" (click)="finishAndClose()">Close</button>
    }

  </div>

</ng-template>
